import * as React from 'react';
import { Grid } from '@mui/material';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import propTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { isSuperAdmin } from 'utils/utils';
import { style } from 'constant/constants';
import { useNavigate } from 'react-router-dom';
import TabPanel from '@mui/lab/TabPanel';

export const styleTab = {
  fontFamily: style.fontFamily,
  fontSize: '3vh',
  textTransform: 'none',
  color: style.LIGHT.primary
};

const tabPanelStyle = { p: 0 };

const CustomTabs = ({ value, setValue }) => {
  const { userData } = useSelector((store) => store.auth);
  const navigate = useNavigate();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Grid sx={{ width: '100%' }}>
      <TabContext value={value}>
        <Grid sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList
            textColor="primary"
            indicatorColor="primary"
            onChange={handleChange}
            aria-label="lab API tabs example">
            <Tab
              label="Stores"
              onClick={() => {
                navigate('/Stores');
              }}
              sx={styleTab}
              value="1"
            />
            {isSuperAdmin(userData.roles) && (
              <Tab
                label="Admins"
                onClick={() => {
                  navigate('/Admins');
                }}
                sx={styleTab}
                value="2"
              />
            )}
            {isSuperAdmin(userData.roles) && (
              <Tab
                label="Brackets"
                onClick={() => {
                  navigate('/Brackets');
                }}
                sx={styleTab}
                value="3"
              />
            )}
            {isSuperAdmin(userData.roles) && (
              <Tab
                label="Strengths"
                onClick={() => {
                  navigate('/Strengths');
                }}
                sx={styleTab}
                value="4"
              />
            )}
          </TabList>
        </Grid>
        <TabPanel sx={tabPanelStyle} value="1"></TabPanel>
        <TabPanel sx={tabPanelStyle} value="2"></TabPanel>
        <TabPanel sx={tabPanelStyle} value="3"></TabPanel>
        <TabPanel sx={tabPanelStyle} value="4"></TabPanel>
      </TabContext>
    </Grid>
  );
};

CustomTabs.propTypes = {
  value: propTypes.number,
  setValue: propTypes.func
};

export default CustomTabs;
